import { backgroundTransitionOnClick, Divider, IconFont, pointer } from '@byecode/ui'
import styled from 'styled-components'

export const StyledDivider = styled(Divider)`
    border-color: var(--color-gray-200);
    margin: 8px 0;
`

export const MenuList = styled.div<{ maxHeight?: number }>`
    width: 100%;
    max-height: ${({ maxHeight }) => (maxHeight ? `${maxHeight}px` : 'auto')};
    display: flex;
    flex-direction: column;
`

export const SpaceList = styled.div`
    flex: 1;
    overflow-y: auto;
`

export const Header = styled.div`
    padding: 4px 16px 8px 16px;
`

export const ItemIcon = styled(IconFont)`
    color: var(--color-gray-500);
    font-size: 14px;
    padding: 0 10px 0 20px;
`

export const ListItemInfo = styled.div`
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const ListItemText = styled.div`
    font-weight: 400;
    font-size: var(--font-size-normal);
    color: var(--color-black);
    white-space: nowrap;
`

export const ListFooter = styled.div`
    height: fit-content;
`

export const ListFooterItem = styled.div<{ selected?: boolean }>`
    display: flex;
    height: 36px;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    flex-flow: row nowrap;
    font-size: var(--font-size-normal);
    ${pointer}

    background-color: ${properties => properties.selected && 'var(--color-gray-50)'};

    &:hover {
        background: var(--color-gray-100);
    }
`
